import { render, staticRenderFns } from "./AdminOfferExpandablePanel.vue?vue&type=template&id=8fd50de2&scoped=true&"
import script from "./AdminOfferExpandablePanel.vue?vue&type=script&lang=js&"
export * from "./AdminOfferExpandablePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd50de2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fd50de2')) {
      api.createRecord('8fd50de2', component.options)
    } else {
      api.reload('8fd50de2', component.options)
    }
    module.hot.accept("./AdminOfferExpandablePanel.vue?vue&type=template&id=8fd50de2&scoped=true&", function () {
      api.rerender('8fd50de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Admin/AdminOfferExpandablePanel.vue"
export default component.exports